import { render, staticRenderFns } from "./AmexLogo.vue?vue&type=template&id=1a80af93&scoped=true&"
var script = {}
import style0 from "./AmexLogo.vue?vue&type=style&index=0&id=1a80af93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a80af93",
  null
  
)

export default component.exports